module.exports = __webpack_public_path__ + "img/life_restart.7a9cea07.png";